import { Component, OnInit, Input,Output, EventEmitter,SimpleChanges, ViewChild, HostListener } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'votes-modal',
  templateUrl: './votes-modal.component.html',
  styleUrls: ['./votes-modal.component.scss']
})
export class VotesModalComponent implements OnInit{
  @Input() votes;
  @Input() type;
  @Output() onClose: EventEmitter<boolean> = new EventEmitter();

  yesVotes = [];
  noVotes = [];
  abstainVotes = [];
  absentVotes = [];
  votesAbsentCount;
  voteAbstainCount;
  voteNCount;
  voteYCount;
  constructor(
    private router: Router  
  ) { 
  }

  ngOnInit(): void{
    document.getElementById("backdrop").style.display = "block"
    document.getElementById("votesModal").style.display = "block"
    document.getElementById("votesModal").classList.add("show")
    this.voteYCount = this.votes.VT_VoteY;
    this.voteNCount = this.votes.VT_VoteN;
    this.voteAbstainCount = this.votes.VT_VoteAbstain;
    this.votesAbsentCount = this.votes.VT_VoteAbsent;

    this.yesVotes = this.votes.VT_VoteResults.filter(result => result.VT_VoteResult == 'Yes' || result.VT_VoteResult == 'yes');
    this.noVotes = this.votes.VT_VoteResults.filter(result => result.VT_VoteResult == 'No' || result.VT_VoteResult == 'no');
    this.abstainVotes = this.votes.VT_VoteResults.filter(result => result.VT_VoteResult == 'Abstain' || result.VT_VoteResult == 'abstain');
    this.absentVotes = this.votes.VT_VoteResults.filter(result => result.VT_VoteResult == 'Absent' || result.VT_VoteResult == 'absent');
    
  }

  @HostListener('unloaded')
  ngOnDestroy() {
    
  }

  getVotes (votes){
    let _votes = [];
    for(let vote of votes){
       _votes.push(vote.VT_Entity)
    }
    return _votes;
  }
  close() {
    //alert('calling')
    document.getElementById("backdrop").style.display = "none"
    document.getElementById("votesModal").style.display = "none"
    document.getElementById("votesModal").classList.remove("show")
    this.onClose.emit(true);

  }
}
